import { logger } from 'utils/system/logger'

interface IWindow extends Window {
    __iasPET: any
}

declare let window: IWindow

export class IasOptimization {
    private adUnit: string

    async init(
        adUnit: string,
        adId: string,
        playerAdSizes: ReadonlyArray<readonly [number, number]>
    ) {
        // Script provided by IAS, altered in order to use
        // ad request params inside JW player ad call.
        let adRequestParamsResolver: (params: string) => void
        const adRequestParamsPromise = new Promise<string>((resolve) => {
            if (!window.__iasPET) {
                logger('error', 'Missing IAS configuration')
                resolve('')
            } else {
                adRequestParamsResolver = resolve
            }
        })

        if (!window.__iasPET) {
            return adRequestParamsPromise
        }

        this.adUnit = adUnit
        let globalAdRequestParams
        let slotAdRequestParamsMap

        const iasDFPUtilities = (() => {
            const equal = '%3D'
            const ampsersand = '%26'
            const comma = '%2C'
            let adSlotDataObj: Record<string, any>
            const parseIASResponseData = (adSlotData: string) => {
                adSlotDataObj = JSON.parse(adSlotData)
            }
            const getIASPageTargetingAsQueryString = () => {
                let iasPageTargeting = ''
                iasPageTargeting = appendRequestParam(
                    iasPageTargeting,
                    'fr',
                    adSlotDataObj.fr
                )
                for (const k in adSlotDataObj.brandSafety) {
                    iasPageTargeting = appendRequestParam(
                        iasPageTargeting,
                        k,
                        adSlotDataObj.brandSafety[k]
                    )
                }
                return iasPageTargeting
            }
            const getIASSlotTargetingAsQueryString = () => {
                const iasSlotTargeting: Record<any, any> = {}
                for (const slotId in adSlotDataObj.slots) {
                    const slotIdValues = adSlotDataObj.slots[slotId]
                    let slotParams = ''
                    for (const key in slotIdValues) {
                        const segments = slotIdValues[key]
                        if (Array.isArray(segments)) {
                            slotParams = slotParams.concat(
                                ampsersand,
                                key,
                                equal
                            )
                            const last = segments.length - 1
                            for (
                                let i = 0, len = segments.length;
                                i < len;
                                i++
                            ) {
                                let separator = comma
                                if (i === last) {
                                    separator = ''
                                }
                                slotParams = slotParams.concat(
                                    segments[i],
                                    separator
                                )
                            }
                        } else {
                            slotParams = appendRequestParam(
                                slotParams,
                                key,
                                segments
                            )
                        }
                        iasSlotTargeting[slotId] = slotParams
                    }
                }
                return iasSlotTargeting
            }
            const appendRequestParam = (
                query: any,
                key: unknown,
                value: unknown
            ) => {
                return query.concat(ampsersand, key, equal, value)
            }
            return {
                parseIASResponseData: parseIASResponseData,
                getIASPageTargetingAsQueryString:
                    getIASPageTargetingAsQueryString,
                getIASSlotTargetingAsQueryString:
                    getIASSlotTargetingAsQueryString
            }
        })()
        const iasDataHandler = (adSlotData: any) => {
            iasDFPUtilities.parseIASResponseData(adSlotData)
            globalAdRequestParams =
                iasDFPUtilities.getIASPageTargetingAsQueryString()
            slotAdRequestParamsMap =
                iasDFPUtilities.getIASSlotTargetingAsQueryString()
            const iasParams =
                // eslint-disable-next-line no-magic-numbers
                globalAdRequestParams.substr(3) + slotAdRequestParamsMap[adId]
            adRequestParamsResolver(iasParams)
            logger('debug', '&cust_params=' + iasParams)
        }
        const iasPETSlots = []
        const adSlots = [adId]
        for (let i = 0; i < adSlots.length; i++) {
            iasPETSlots.push({
                adSlotId: adSlots[i],
                size: playerAdSizes,
                adUnitPath: this.adUnit,
                type: 'video'
            })
        }
        window.__iasPET.queue.push({
            adSlots: iasPETSlots,
            dataHandler: iasDataHandler
        })
        return adRequestParamsPromise
    }
}
